import React, { Fragment } from "react";

import { MDBModal, MDBRangeInput } from "mdbreact";
import { useEffect } from "react";
import { BarraCategoria } from "../categoria/BarraCategoria";

export const NavFiltrosProductos = ({
    modalSidebarFiltros,
    setModalSidebarFiltros,
    listaCategorias,
    categoriaActual,
    listaProductos4,
}) => {
    useEffect(() => {
        if (modalSidebarFiltros) {
            document.body.style.overflow = "hidden";
            document.documentElement.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        }

        return () => {
            document.body.style.overflow = "auto";
            document.documentElement.style.overflow = "auto";
        };
    }, [modalSidebarFiltros]);

    return (
        <MDBModal
            isOpen={modalSidebarFiltros}
            tabIndex="-1"
            className="fixed right-0 top-0 h-full w-[100%] lg:h-screen lg:w-96 lg:max-w-full m-0 bg-white shadow-lg"
            toggle={() => {
                setModalSidebarFiltros(false);
            }}
            contentClassName="h-full lg:h-auto"
        >
            <div className="h-full lg:h-screen flex flex-col relative">
                <div className="flex items-center justify-between bg-secondary-personalize px-4 py-4">
                    <div className="w-40 h-8 lg:h-16 overflow-hidden relative">
                        <a
                            href={
                                "/" +
                                "?e=".concat(
                                    localStorage.getItem("empresa")
                                )
                            }
                        >
                            <img
                                src="/img/logo-fondo.png"
                                alt="Logo"
                                className="absolute top-3 lg:top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2"
                            />
                        </a>
                    </div>
                    <span
                        className="cursor-pointer"
                        onClick={() => setModalSidebarFiltros(false)}
                    >
                        <i className="fas fa-times text-xl text-white"></i>
                    </span>
                </div>

                <BarraCategoria
                    listaCategorias={listaCategorias}
                    categoriaActual={categoriaActual}
                    listaProductos4={listaProductos4}
                />
            </div>
        </MDBModal>
    );
};
